.wrapper {
    width: 280px;
}
